import React from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import { muiTheme } from '@pbt/pbt-ui-components'

import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'
import type { QuestionTimelineItemEntry } from '~/types'

import QuestionTitle from '../QuestionTitle'
import AnswerItem from './AnswerItem'
import { getListComponent, StyledUnBulletedList } from './cardUtils'

const AnswerList = ({ entries }: { entries: QuestionTimelineItemEntry[] }) => {
  const isCVCIntakeQuestionnaireEnabled = useSelector(
    getFeatureToggle(FeatureToggle.CVC_INTAKE_QUESTIONNAIRE),
  )
  const isFollowUpQuestionsEnabled = useSelector(
    getFeatureToggle(FeatureToggle.FOLLOW_UP_QUESTIONS),
  )
  const StyledList = getListComponent(entries)

  return (
    <StyledList>
      {entries.map((entry) => {
        const { followUpQuestionLog } = entry

        const FollowUpStyledList = followUpQuestionLog
          ? getListComponent(followUpQuestionLog.entries || [])
          : StyledUnBulletedList

        return (
          <AnswerItem entry={entry} key={entry.id}>
            {isFollowUpQuestionsEnabled && followUpQuestionLog?.entries && (
              <Grid container>
                <QuestionTitle
                  questionColor="grayGray1"
                  questionSubText={followUpQuestionLog.questionSubText}
                  questionSubTextStyle={{
                    fontSize: isCVCIntakeQuestionnaireEnabled
                      ? muiTheme.typography.body2.fontSize
                      : muiTheme.typography.body1.fontSize,
                  }}
                  questionText={followUpQuestionLog.questionText || ''}
                  questionTextStyle={{
                    fontSize: isCVCIntakeQuestionnaireEnabled
                      ? muiTheme.typography.body1.fontSize
                      : muiTheme.typography.h3.fontSize,
                  }}
                />
                <FollowUpStyledList>
                  {followUpQuestionLog.entries?.map((followUpEntry) => (
                    <AnswerItem entry={followUpEntry} key={followUpEntry.id} />
                  ))}
                </FollowUpStyledList>
              </Grid>
            )}
          </AnswerItem>
        )
      })}
    </StyledList>
  )
}

export default AnswerList
